var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._g({},_vm.$listeners),[_vm._l((_vm.highlights),function(item){return [(!item.isHighlighted)?[_vm._v(_vm._s(item.text))]:[_c('mark',{key:item.index,staticClass:"highlight",attrs:{"index":item.index,"text":item.text}},[_vm._v(_vm._s(item.text))])]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }